import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LinkedMember } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-contact-preview-modal',
  templateUrl: './contact-preview-modal.component.html',
  styleUrls: ['./contact-preview-modal.component.scss'],
})
export class ContactPreviewModalComponent implements OnInit {
  public data: LinkedMember;

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef
  ) {}

  ngOnInit(): void {
    if (this.config?.data) {
      this.data = this.config.data.data;
    }
  }

  public close() {
    this.ref.close();
  }
}
